


















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import { Route } from '@/models/route';
import { Sponsor } from '@/models/sponsor';

import RouteSlideImage from '@/components/route-slide-image.vue';
import SponsorCard from '@/components/sponsor-card.vue';
import Chartist from 'chartist';
import FormatHelper from '@/services/format-helper';

@Component({
    components: { RouteSlideImage, SponsorCard }
})
export default class RouteDetailPage extends Vue {
    @Prop(String) public routeId: string;

    public route: Route = {} as Route;

    public isFavorite: boolean = false;
    public heightProfileChart = {};
    public heightProfileOptions = {};
    public hideCaptions = false;

    public async created() {
        await this.$store.waitUntilReady();
        const id = parseInt(this.routeId, 10);
        this.route = await this.$store.getRoute(id);
    }

    public mounted() {
        (this.$refs.gallerySlider as any).swiper.on('tap', this.slideTapped);
    }

    @Watch('route')
    public async updateGallery() {
        await this.$nextTick();
        // @ts-ignore
        this.$refs.gallerySlider.swiper.update();
    }

    public slideTapped(event: Event) {
        const tagName = (event.srcElement as any).tagName;
        if (tagName === 'P' || tagName === 'IMG') {
            this.toggleCaptionVisibility();
        }
    }

    public toggleCaptionVisibility() {
        this.hideCaptions = !this.hideCaptions;
    }

    public resolveProfile(profileId: number): string {
        return this.$t('route_profile.' + profileId) as string;
    }

    public resolveSponsor(sponsorId: number): Sponsor {
        return this.$store.sponsors.find(s => s.id === sponsorId);
    }

    private isEmpty(str: string): boolean {
        return (!str || 0 === str.length);
    }

    private startRoute() {
        const routeSource = [this.route];
        const poiSource = this.$store.pois.filter(p => p.route === this.route.id);

        this.$f7router.navigate(`/routes/${this.routeId}/map/`, {
            props: {
                routeSource: routeSource,
                poiSource: poiSource,
                mainRoute: this.route,
                disableLocalization: true,
            }
        });

        this.$ga.event({
            eventCategory: 'route',
            eventAction: 'started',
            eventLabel: this.route.number
        });
    }

    @Watch('route')
    private updateHeightProfile() {

        // Not necessary anymore, this is done by api now
        // const simplified = this.route.height_profile.filter(
        //     (p, i) => i % 10 === 0
        // );

        const data = this.route.height_profile;

        let minHeight = Number.MAX_SAFE_INTEGER;
        let maxHeight = Number.MIN_SAFE_INTEGER;
        data.forEach(point => {
            const height = point.y;
            minHeight = Math.min(minHeight, height);
            maxHeight = Math.max(maxHeight, height);
        });

        minHeight = Math.floor(minHeight / 100) * 100;
        maxHeight = Math.ceil(maxHeight / 100) * 100;

        // let diff be in the minimum 600
        let diffHeight = maxHeight - minHeight;
        diffHeight = Math.max(diffHeight, 400);

        this.heightProfileChart = {
            series: [data]
        };

        this.heightProfileOptions = {
            low: minHeight,
            high: minHeight + diffHeight,
            showArea: true,
            showPoint: false,
            fullWidth: true,
            axisX: {
                showLabel: false,
                showGrid: false
            }
        };
    }

    get routeLength() {
        return FormatHelper.prettyLength_km(this.route.length);
    }

    get uphill() {
        return FormatHelper.length_m(this.route.uphill);
    }

    get downhill() {
        return FormatHelper.length_m(this.route.downhill);
    }

    get duration() {
        return FormatHelper.prettyTime_Hm(this.route.duration);
    }
}
